type JwtPayload = {
  exp: number;
  iat: number;
  iss: string;
  issuingUrl: string;
  jti: string;
  sessionId: string;
  /**
   * Represents `userId`
   * @note Stringified number ('123')
   * */
  sub: string;
};

export function safeParseJwtPayload(token: string) {
  try {
    const jwtRaw = JSON.parse(atob(token.split('.')[1]));

    return isJwtPayload(jwtRaw) ? jwtRaw : null;
  } catch {
    return null;
  }
}

function isJwtPayload(data: unknown): data is JwtPayload {
  if (typeof data !== 'object' || data === null) return false;

  return (
    'exp' in data &&
    'iat' in data &&
    'iss' in data &&
    'issuingUrl' in data &&
    'jti' in data &&
    'sessionId' in data &&
    'sub' in data &&
    typeof data.iat === 'number' &&
    typeof data.exp === 'number'
  );
}
